import {DialogAside} from './Dialog.Aside'
import {DialogContent} from './Dialog.Content'
import {DialogExternalLink} from './Dialog.ExternalLink'
import {DialogSection} from './Dialog.Section'
import {DialogRoot} from './DialogRoot'

import type {DialogRootProps} from './DialogRoot'
import type {ComponentProps} from 'react'

export type DialogProps = DialogRootProps

export interface DialogContentProps extends ComponentProps<'div'> {
  hasAside?: boolean
}

/** @deprecated use DialogNew instead */
export const Dialog = Object.assign(DialogRoot, {
  Section: DialogSection,
  Aside: DialogAside,
  Content: DialogContent,
  ExternalLink: DialogExternalLink, // unused?
})
